import React, { useEffect, useState } from "react";
//outsource
import { Row, Col, Space, Button } from "antd";
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
//components
import TimeBranchSelect from "./component/time_branch_select";
import TimeFrom from "./component/time_from";
import TimeTo from "./component/time_to";
import { exportToCSV } from "../functions/csv_converter";

//redux
import { useDispatch, useSelector } from "react-redux";
import { company } from "../../../store/report/report.selector";
import { branchsSelector } from "../../../store/branch/branch.selector";
import {
  from,
  to,
  totalWorkingSelector,
  rangeSelector,
  reportDataSelector,
} from "../../../store/report/report.selector";

const TimeSheetTopbar = ({ handleView }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [view, setView] = useState(true);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branchs = useSelector(branchsSelector);
  const companyId = useSelector(company);
  const dataFrom = useSelector(from);
  const dataTo = useSelector(to);
  const totalWorking = useSelector(totalWorkingSelector);
  const range = useSelector(rangeSelector);
  const reportData = useSelector(reportDataSelector);

  const disabled = companyId === null || false;

  // -------------------------- FUNCTION ------------------------
  const handleDownload = () => {
    exportToCSV({
      reportData,
      branch: companyId,
      branchs,
      from: dataFrom,
      to: dataTo,
      totalWorking,
      range,
    });
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    setView(true);
  }, [dataFrom, dataTo, companyId]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderTitle()}
        </Col>
        <Col style={{ margin: "10px 0px" }} xl={24} lg={24} md={24} xs={24}>
          {renderFromTo()}
        </Col>
      </Row>
    );
  };

  const renderTitle = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={8} lg={8} md={8} xs={8}>
          <h1>Timesheet Details</h1>
        </Col>
        <Col xl={8} lg={8} md={8} xs={8}>
          <TimeBranchSelect />
        </Col>
      </Row>
    );
  };

  const renderFromTo = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={8} lg={8} md={8} xs={8}>
          <TimeFrom disabled={disabled} />
        </Col>
        <Col xl={8} lg={8} md={8} xs={8}>
          <TimeTo disabled={disabled} />
        </Col>
        <Col xl={8} lg={8} md={8} xs={8}>
          {renderGroupButton()}
        </Col>
      </Row>
    );
  };

  const renderGroupButton = () => {
    return (
      <Space>
        <Button
          type="primary"
          icon={<EyeOutlined />}
          disabled={disabled || !view}
          onClick={() => {
            setView(false);
            handleView();
          }}
        >
          View
        </Button>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          disabled={disabled || view}
          onClick={handleDownload}
        >
          Download
        </Button>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col xl={12} lg={12} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};

export default TimeSheetTopbar;
